export default __webpack_public_path__ + "static/media/wechat-logo-transparent-white.e47172bb.png";